import { render, staticRenderFns } from "./infoPostBlock.vue?vue&type=template&id=550ffd41&scoped=true&"
import script from "./infoPostBlock.vue?vue&type=script&lang=js&"
export * from "./infoPostBlock.vue?vue&type=script&lang=js&"
import style0 from "./infoPostBlock.vue?vue&type=style&index=0&id=550ffd41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ffd41",
  null
  
)

export default component.exports